import { Paper } from "@material-ui/core";
import lightGreen from "@material-ui/core/colors/lightGreen";
import red from "@material-ui/core/colors/red";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import * as _ from "lodash";
import * as React from "react";
import { connect } from "react-redux";

import { Dispatch, StoreState } from "../store";
import { DashboardFilterState, Score } from "../types/index";
import {
  dashboardFiltersPartiallyEqual,
  format,
  numberFormat,
} from "../utilities";
import PieChart from "./generic/PieChart";

function mapStateToProps({ dashboardFilter, cluster }: StoreState) {
  return {
    cluster,
    dashboardFilter,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    fetchCluster: (dashboardFilter: DashboardFilterState) =>
      dispatch.cluster.fetchCluster(dashboardFilter),
  };
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const CLV_COLORS = [lightGreen[100], lightGreen[500], lightGreen[900]];
const CHRUN_COLORS = [red[100], red[300], red[800]];

interface State {
  expectingNewChartData: boolean;
}

class PieChartCLVorChurn extends React.Component<
  Props & StyledComponentProps,
  State
> {
  public state = {
    expectingNewChartData: false,
  };
  public componentDidMount() {
    if (this.props.cluster.data.length === 0) {
      this.props.fetchCluster(this.props.dashboardFilter);
    }
  }

  public componentDidUpdate(previousProps: Props) {
    // cluster-state not only affects this component but also StackedBarChart-component
    // Therefore although for this component changes in the date range filter are irrelevant,
    // they can't be excluded from the fetch conditions. Hence the solution with an additional
    // state that prevents a chart loading animation when no new chart data is expected.
    if (previousProps.dashboardFilter !== this.props.dashboardFilter) {
      this.props.fetchCluster(this.props.dashboardFilter);
      if (
        !dashboardFiltersPartiallyEqual(
          previousProps.dashboardFilter,
          this.props.dashboardFilter,
          ["dateRange"]
        )
      ) {
        this.setState({ expectingNewChartData: true });
      } else {
        this.setState({ expectingNewChartData: false });
      }
    }
  }

  public render() {
    const { classes } = this.props;

    const colors =
      this.props.dashboardFilter.score === Score.CLV
        ? CLV_COLORS
        : CHRUN_COLORS;
    const scoreLabel =
      this.props.dashboardFilter.score === Score.CHURN ? "Churn Score" : "CLV";
    const dateLabel = format(new Date(), "MMMM yyyy");

    return (
      <Paper className={classes && classes.paper}>
        <PieChart
          loading={
            this.props.cluster.loading && this.state.expectingNewChartData
          }
          title={`Verteilung ${scoreLabel} für ${dateLabel}`}
          data={this.filteredData()}
          colorScheme={colors}
          tooltipFormatter={(v) => numberFormat(Number(v), false)}
          showTooltip
          showLegend
        />
      </Paper>
    );
  }

  private filteredData = () => {
    const t = _.last(this.props.cluster.data);
    const data = t
      ? [
          { label: "gering", value: t.min },
          { label: "mittel", value: t.mid },
          { label: "hoch", value: t.max },
        ].filter((v) => v.value != null)
      : [];

    return data;
  };
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PieChartCLVorChurn));



// WEBPACK FOOTER //
// ./src/components/PieChartCLVorChurn.tsx